import { AbstractControl, ValidatorFn } from '@angular/forms';

export const validateFilesize = (file: File, maxSize: number) => {
    return file.size <= maxSize;
};

export const filesize = (maxSize: number): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } => {
        const v: File = control.value;

        if (!v) {
            return null;
        }

        return validateFilesize(v, maxSize) ? null : { filesize: true };
    };
};
